import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["type", "disabled"]
const _hoisted_2 = { class: "btn-content" }

export function render(_ctx, _cache) {
  const _component_AppIcon = _resolveComponent("AppIcon")
  const _component_router_link = _resolveComponent("router-link")

  return (!_ctx.link)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: _normalizeClass(_ctx.classes),
        type: _ctx.submit ? 'submit' : 'button',
        disabled: _ctx.disabled,
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('click'))),
        style: _normalizeStyle(_ctx.styles)
      }, [
        (_ctx.icon)
          ? (_openBlock(), _createBlock(_component_AppIcon, {
              key: 0,
              icon: _ctx.icon,
              color: _ctx.iconColor
            }, null, 8, ["icon", "color"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ], 14, _hoisted_1))
    : (_openBlock(), _createBlock(_component_router_link, {
        key: 1,
        class: _normalizeClass(_ctx.classes),
        to: _ctx.link,
        style: _normalizeStyle(_ctx.styles)
      }, {
        default: _withCtx(() => [
          (_ctx.icon)
            ? (_openBlock(), _createBlock(_component_AppIcon, {
                key: 0,
                icon: _ctx.icon,
                color: _ctx.iconColor
              }, null, 8, ["icon", "color"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _: 3
      }, 8, ["class", "to", "style"]))
}